import { render } from "./Productos-App.vue?vue&type=template&id=a2fd66d6&scoped=true"
import script from "./Productos-App.vue?vue&type=script&lang=js"
export * from "./Productos-App.vue?vue&type=script&lang=js"

import "./Productos-App.vue?vue&type=style&index=0&id=a2fd66d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2fd66d6"]])

export default __exports__